import { Flex } from 'foundations-components/components/Flex';
import { FileAttachment } from 'foundations-components/transitional/components/FileAttachment';
import { jsx as _jsx } from "react/jsx-runtime";
export function FileReferencesBlock({
  block
}) {
  const {
    fileReferences
  } = block;
  if (!fileReferences.length) return null;
  return /*#__PURE__*/_jsx(Flex, {
    "data-block-type": "file-references",
    flexWrap: "wrap",
    justifyContent: "end",
    gap: "200",
    children: fileReferences.map(({
      fileId,
      fileName
    }) => {
      var _fileName$split$pop;
      return /*#__PURE__*/_jsx(FileAttachment, {
        size: "small",
        fileName: fileName,
        fileType: fileName.includes('.') ? (_fileName$split$pop = fileName.split('.').pop()) !== null && _fileName$split$pop !== void 0 ? _fileName$split$pop : '' : ''
      }, fileId);
    })
  });
}